import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useFullScreenHandle } from "react-full-screen"
import { Stack } from "@fluentui/react";
import { GlobalContext } from '../../hooks/globalContext'
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { iframeStyle } from "../../styles/customStyles";
import apiCall from "../../utility/api";
import { Text } from "@fluentui/react-components";

export const Analytics = () => {
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    const [urlSrc, setUrlSrc] = useState('');
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handle = useFullScreenHandle();
    const handleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
        isFullScreen ? handle.exit() : handle.enter();
    };

    const getLightDashUrl = async () => {
        try {
            let {data, status} = await apiCall('/Investigate/LD', undefined, 'GET');

            if(status === "success"){
                setUrlSrc(data?.url);
                
                return true;
            }
        } catch (error) {
            console.log("getLightDashUrl error=", error);
        }

        setUrlSrc('');
    }

    useEffect(() => {
       getLightDashUrl();
    }, []);

    return (
        <Stack tokens={{ childrenGap: 10 }} horizontalAlign="start">
            <Breadcrumbs pageName="Analytics" subPageName="" subPageLink={`/investigate/analytics`} />
            <iframe src={urlSrc} style={iframeStyle} allowTransparency />
        </Stack>
    );  
};
